module.exports = __webpack_public_path__ + "img/newspaper.f746be39.svg";